<template>
    <section class="layout layout-scale" :class="{ 'opacity-0': !isAlreadyShow }">
        <quiz-header :title="stripHtmlTag(title)" :currentQuizIndex="currentQuizIndex" :questionCount="questionCount" />

        <bg-music-mute-btn v-if="playerSound.effectMusic" class="pr-4" :is-muted="isMuted"></bg-music-mute-btn>

        <div class="content mx-0 pt-3">
            <div class="content-container" v-if="type == 'poll'">
                <pollResult
                    :question-image="question.image"
                    :show-summary="showSummary"
                    :image-answer="imageAnswer()"
                    :answers.sync="question.answers"
                    :title="question.title"
                    user-type="player"
                />
            </div>
            <div class="content-container" v-if="type == 'quiz'">
                <quiz-result-player
                    @getHeaderRect="getHeaderRect"
                    @onShowCorrectAnswer="onClickShowCorrectAnswer"
                    :question-image="question.image"
                    :player-name="name"
                    :show-summary="showSummary"
                    :results.sync="quizScore"
                    :current-quiz-index="currentQuizIndex"
                    :player-result.sync="playerResult"
                    :title="question.title"
                    :user-effect-music="playerSound.effectMusic"
                    :wrongAudio="audioWrong"
                    :is-last-question="currentQuizIndex + 1 === questionCount"
                    :is-resized="isAlreadyShow"
                    :is-show-correct-button.sync="isShowCorrectAnswerButton"
                    user-type="player"
                />
            </div>
        </div>
        <div class="footer" :style="{ paddingBottom: type == 'poll' ? '15px' : false }">
            <div class="py-2">
                <div class="flex flex-col items-center justify-center">
                    <button
                        v-if="isEndQuiz"
                        :disabled="!isAllowToPressNext"
                        @click="handleClickNextToSummary"
                        id="end-btn"
                        class="theme-button btn btn-large uppercase font-size-22 font-opensans mb-3"
                        :class="{ 'pointer-events-none opacity-0': !isEndQuiz }"
                    >
                        {{ $t('playlive_result_button_final') }}
                    </button>
                    <div v-if="!isEndQuiz">
                        <p
                            v-if="isNextEnable"
                            class="theme-ui-text-color theme-question-shadow font-size-18 font-bold text-white"
                        >
                            {{ $t('playlive_result_wait') }}
                        </p>
                        <p
                            v-if="!isNextEnable"
                            class="theme-ui-text-color theme-question-shadow font-size-18 font-bold text-white"
                        >
                            {{ $t('playlive_result_ready') }}
                        </p>
                    </div>
                    <div v-else>
                        <p class="theme-ui-text-color theme-question-shadow font-size-18 font-bold text-white"></p>
                    </div>
                </div>
            </div>
        </div>

        <correct-answers-popup
            v-if="isShowCorrectAnswer"
            :question="question"
            :show-title="false"
            :rect="popupCurrentRect"
            :is-rect-bottom="true"
            @close="isShowCorrectAnswer = false"
            :is-animate="true"
        />

        <auth-popup
            v-if="showAuthPopup"
            :webview-redirect-to="createWebviewRedirectTo()"
            :show-third-party-in-webview="false"
            :loginTitle="[$t('auth_header_login_see_correct')]"
            @login-success="loginSuccess"
            @register-success="loginSuccess"
            @close="showAuthPopup = false"
        />

        <payment-popup
            :quiz-id="quizId"
            @close="showPaymentPopup = false"
            @success="paymentSuccess"
            v-if="showPaymentPopup"
        />

        <socket-reconnect-modal
            v-if="showPlayerPopup"
            @ok="onPlayerClickOk"
            :icon="playerPopupIcon"
            :show-footer="true"
            :retry-fail-message="playerRetryFailMessage"
            :ok-button="playerOkButton"
            :title="playerPopupTitle"
            :message="playerPopupMessage"
        />
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PollResult from '@/components/PollResult.vue'
import QuizResultPlayer from '@/components/QuizResultPlayer.vue'
import answer from '@/lib/answer.js'
import popup from '@/lib/popup.js'
import ResizeScale from '@/lib/resize-scale.js'
import CorrectAnswersPopup from '@/components/CorrectAnswersPopup.vue'
import QuizHeader from '@/components/QuizHeader.vue'
import { isLoggedIn, validateToken } from '@/lib/user.js'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'
import PaymentPopup from '@/components/PaymentPopup'
import BgMusicMuteBtn from '@/components/BgMusicMuteBtn.vue'
import SocketReconnectModal from '@/components/SocketReconnectModal.vue'
import helperMixins from '@/mixins/helper.js'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import setBackgroundQuestion from '@/mixins/set-bg-question.js'
import { playerSocketSetting } from '@/mixins/live-quiz-socket.js'

export default {
    components: {
        PollResult,
        QuizResultPlayer,
        CorrectAnswersPopup,
        QuizHeader,
        AuthPopup,
        PaymentPopup,
        BgMusicMuteBtn,
        SocketReconnectModal
    },

    mixins: [AuthPopupMixin, helperMixins, socketConnectionMixin, setBackgroundQuestion],

    watch: {
        playerSound: {
            handler(data) {
                if (this.question.spotify_track) {
                    if (!data.questionMusic || !this.isPlayingMusic) {
                        this.handleMute(this.audioSpotify, true)
                    } else {
                        this.handleMute(this.audioSpotify, false)
                        this.audioSpotify.muted = false
                    }
                }
            },
            deep: true
        },

        isMuted(muted) {
            this.audioPlucky.muted = muted
            this.audioWrong.muted = muted
        }
    },

    mounted: function () {
        this.touchActionNone()
        this.checkMasterActive()

        this.audioPlucky.muted = this.isMuted
        this.audioWrong.muted = this.isMuted

        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        if (this.currentQuizIndex + 1 == this.questionCount) {
            this.$socket.emit('user_finish_quiz', {
                room: this.code,
                name: this.name
            })
        }

        this.$socket.emit('user_waiting_result', {
            type: this.type,
            room: this.code,
            question_index: this.currentQuizIndex
        })

        if (this.type == 'poll') {
            // this.$store.commit('updateRemoveAppPaddingX', true)
            this.resetAnswerScore()
        }

        window.addEventListener('unload', this.handleUserCloseWindow)

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'result') {
                this.componentsAlreadyCount++

                if (this.componentsAlreadyCount == 2) {
                    this.resizeScaleQuizFrame()
                    this.checkShowCorrectAnswerWhenWrong()
                }
            }
        })

        this.checkCurrentGame()
        this.findOrderAbility()
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    sockets: {
        user_finished_quiz: function (data) {
            return data
        },

        no_user_in_room: function () {},

        master_pressed_next: function () {
            this.isNextEnable = false
            if (this.playerSound.effectMusic) {
                this.audioPlucky.play()
            }
            this.isAllowToPressNext = true

            if (typeof navigator.vibrate !== 'undefined') {
                navigator.vibrate(500)
            }

            this.$store.dispatch('player/handleNextQuestionIndex')
            this.$router.push({
                name: 'countdown',
                params: {
                    code: this.code
                }
            })
        },

        user_answered_result_all: function (data) {
            this.isNextEnable = false
            if (this.playerSound.effectMusic) {
                this.audioPlucky.play()
            }
            this.isAllowToPressNext = true

            if (typeof navigator.vibrate !== 'undefined') {
                navigator.vibrate(500)
            }

            setTimeout(() => {
                this.$store.commit('player/updateCurrentQuizIndex', data.nextIndex)
                this.$router.push({
                    name: 'countdown',
                    params: {
                        code: this.code
                    }
                })
            }, 3000)
        },

        master_pressed_end: function () {
            this.isEndEnable = false
            this.isNextEnable = true
            this.isAllowToPressNext = true
            if (this.playerSound.effectMusic) {
                this.audioPlucky.play()
            }

            if (typeof navigator.vibrate !== 'undefined') {
                navigator.vibrate(500)
            }

            this.handleClickNextToSummary()
        },

        user_answered_result: function (data) {
            this.userCount = data.users.length

            if (this.type == 'poll') {
                this.question.answers = answer.sanitizePollAnswer(
                    data.result,
                    this.question.answers,
                    this.currentQuizIndex
                )
                this.answeredUsers = answer.getPollAnsweredUsers()
            }

            if (this.type == 'quiz') {
                this.quizResults = answer.sanitizeQuizAnswer(data.result, this.currentQuizIndex)
                this.quizScore = answer.sanitizeQuizOverallAnswer(data.result)
                this.answeredUsers = this.quizResults.length
                this.playerResult = answer.getCurrentPlayerResult(this.quizResults, this.name)
            }

            if (this.answeredUsers >= this.userCount) {
                this.isAllowToPressNext = true
                this.isEndEnable = false
                this.isNextEnable = true
            }
        },

        user_ended_game: function (data) {
            this.userCount = data.users.length

            if (this.answeredUsers >= this.userCount) {
                this.isNextEnable = true
                this.isEndEnable = false
                this.isAllowToPressNext = true
            }
        },

        continue_game_joined: function (data) {
            const currentIndex = this.currentQuizIndex

            let txtDone =
                this.type === 'poll'
                    ? this.firstUppercase(this.$t('playlive_share_type_poll'))
                    : this.firstUppercase(this.$t('playlive_share_type_quiz'))
            let txtCancelled =
                this.type === 'poll' ? this.$t('playlive_share_type_poll') : this.$t('playlive_share_type_quiz')

            if (currentIndex !== data.index && data.index > -1 && data.index != null) {
                popup.alert(
                    this.$t('playlive_alert_timeup'),
                    function () {
                        this.isNextEnable = false
                        this.$store.commit('player/updateCurrentQuizIndex', data.index)
                        this.$router.push({
                            name: 'redirect-quiz',
                            params: {
                                code: this.$route.params.code
                            }
                        })
                    }.bind(this)
                )
            }

            if (data.index === -1) {
                this.isEndEnable = false
                this.isNextEnable = true

                popup.alert(
                    this.$t('playlive_alert_done', { type: txtDone }),
                    function () {
                        this.$router.replace({
                            name: 'summary'
                        })
                    }.bind(this)
                )
            }

            if (data.index == null) {
                popup.alert(this.$t('playlive_alert_cancelled', { type: txtCancelled }), function () {
                    window.location.href = '/join'
                })
            }
        },

        master_pressed_show_correct_answer: function (data) {
            if (data.isPaidUser) {
                this.isShowCorrectAnswer = true
            }
        },

        user_receive_ping: function (data) {
            this.lastMasterPingAt = new Date()
            this.$socket.emit('user_ping_back_to_master', {
                room: data.room,
                name: this.name
            })
        },

        ...playerSocketSetting
    },

    computed: {
        ...mapGetters({
            question: 'player/getCurrentQuiz',
            questionCount: 'player/getQuestionCount',
            audioPlucky: 'getPluckyAudio',
            audioWrong: 'getWrongAudio',
            parentQuizCode: 'player/parentQuizCode',
            playerSound: 'player/getPlayerSound',
            audioSpotify: 'getSpotifyAudio'
        }),

        ...mapState({
            quizId: state => state.player.quiz._id.$oid,
            quiz: state => state.player.quiz,
            name: state => state.player.name,
            code: state => state.player.quiz.code,
            type: state => state.player.quiz.type,
            title: state => state.player.quiz.title,
            isEndQuiz: state => state.player.isEndQuiz,
            currentQuizIndex: state => state.player.currentQuizIndex,
            showSummary: state => state.player.quiz.show_result_on_user_device,
            showCorrectAnswerWhenWrong: state => state.player.quiz.show_correct_answer,
            isPlayTogether: state => state.player.isPlayTogether,
            orderAbility: state => state.orderAbility,
            isMuted: state => state.isMuted
        })
    },

    data: function () {
        return {
            isNextEnable: true,
            isEndEnable: true,
            userCount: 0,
            answeredUsers: 0,
            quizResults: [],
            quizScore: [],
            playerResult: null,
            isAllowToPressNext: false,
            isShowCorrectAnswer: false,
            componentsAlreadyCount: 0,
            isAlreadyShow: false,
            popupCurrentRect: null,
            isShowCorrectAnswerButton: false,
            showPaymentPopup: false,
            isClickEnd: false
        }
    },

    methods: {
        handleUserCloseWindow: function () {
            this.$store.dispatch('player/emitUserEndGameToSocket', {
                room: this.code,
                name: this.name,
                socket: this.$socket
            })
        },

        resetAnswerScore: function () {
            this.question.answers.forEach(
                function (answer, index) {
                    this.question.answers[index].score = 0
                }.bind(this)
            )
        },

        handleClickNext: function (e) {
            if (!this.isAllowToPressNext) {
                return typeof e.preventDefault == 'function' ? e.preventDefault() : null
            }

            this.$store.dispatch('player/handleNextQuestionIndex')

            this.$router.replace({
                name: 'quiz',
                params: {
                    code: this.$route.params.code
                }
            })
        },

        handleClickNextToSummary: function (e) {
            //(mixins) remove backgroundImage, video, fade
            this.removeBackdrop()
            this.removeVideoBackdrop()

            if (!this.isAllowToPressNext) {
                return typeof e.preventDefault == 'function' ? e.preventDefault() : null
            }

            if (this.isAllowToPressNext) {
                document.querySelector('#end-btn').style.pointerEvents = 'none'
            }

            if (this.isClickEnd) {
                return
            }

            this.isClickEnd = true

            this.$store.dispatch('disableNoSleep')

            return this.$router.replace({
                name: 'summary'
            })
        },

        imageAnswer: function () {
            return answer.isAllImageAnswer(this.question.answers)
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: false
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')

            this.isAlreadyShow = true
        },

        checkCurrentGame: function () {
            this.$socket.emit('check_game_index', {
                room: this.code
            })
        },

        getHeaderRect: function (rect) {
            if (rect) {
                this.popupCurrentRect = rect
            }
        },

        checkShowCorrectAnswerWhenWrong: function () {
            this.isShowCorrectAnswerButton = !this.playerResult && this.showCorrectAnswerWhenWrong
        },

        onClickShowCorrectAnswer: function () {
            if (!isLoggedIn()) {
                this.showAuthPopup = true
                return
            }

            if (!this.orderAbility.can_download_report) {
                this.showPaymentPopup = true
                return
            }

            validateToken()
                .then(() => {
                    this.isShowCorrectAnswer = true
                })
                .catch(() => {
                    this.showAuthPopup = true
                })
        },

        paymentSuccess: function (payload) {
            this.findOrderAbility()
            this.trackPay(payload.method, `Pay_${this.parentQuizCode}_live`)
        },

        findOrderAbility: function () {
            if (isLoggedIn()) {
                this.$store.dispatch('findOrderAbility')
            }
        }
    },

    beforeRouteLeave(to, from, next) {
        let self = this

        window.onbeforeunload = function () {}

        if (
            (to.name === 'countdown' && !self.isNextEnable) ||
            (to.name === 'summary' && self.isNextEnable && !self.isEndEnable) ||
            (to.name == 'redirect-quiz' && !self.isNextEnable)
        ) {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    this.$store.dispatch('player/emitUserEndGameToSocket', {
                        room: self.code,
                        name: self.name,
                        socket: self.$socket
                    })

                    window.location.href = '/join'

                    // next()
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
    margin-top: -1rem;
    margin-right: -1rem;
    margin-left: -1rem;

    .content {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    @media (max-width: 575px) {
        height: calc(100vh);
        height: calc((var(--vh, 1vh) * 100) - 1rem);
    }

    @media (max-width: 320px) {
        height: calc(100vh);
        height: calc((var(--vh, 1vh) * 100));
    }
}

.btn {
    padding: 0.6rem 1.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }

    section.layout .footer {
        bottom: 0;
        padding-bottom: 0;
    }
}
</style>
